import React from 'react';
import Bodenfeuchte from '../components/Bodenfeuchte';
import './home.css'; // gleiche Styles wie bei Home verwenden

function BodenfeuchteJochberg() {
  return (
    <div
      className="home-container"
      role="main"
      aria-labelledby="bodenfeuchte-jochberg-heading"
    >
      <div className="home-diagramm">
        <div className="wetter-container">
          <h1 id="bodenfeuchte-jochberg-heading">BODENFEUCHTE</h1>
        </div>

        <Bodenfeuchte ort="jochberg" />
      </div>
    </div>
  );
}

export default BodenfeuchteJochberg;
